import React from 'react'
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { ConfigProvider, Layout, theme } from 'antd'
import esES from 'antd/locale/es_ES'
import Login from './pages/Login'
import ClientPortal from './pages/ClientPortal'
import Dashboard from './pages/Dashboard'
import Clients from './pages/Clients'
import Payments from './pages/Payments'
import Classes from './pages/Classes'
import Attendance from './pages/Attendance'
import Modos from './pages/Modos'
import WhatsAppConfig from './pages/WhatsAppConfig'
import Prices from './pages/Prices'
import Navbar from './components/Navbar'
import PrivateRoute from './components/PrivateRoute'
import { AuthProvider, useAuth } from './context/AuthContext'

const { Content, Footer } = Layout

function AppContent() {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) return <div>Cargando...</div>

  // El portal de clientes es completamente independiente, sin navbar ni layout admin
  if (location.pathname === '/portal') {
    return <ClientPortal />
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {user && <Navbar />}
      <Content style={{ padding: '24px 28px', marginTop: user ? 56 : 0, background: '#111113', minHeight: 'calc(100vh - 100px)', overflow: 'hidden' }}>
        <Routes>
          <Route path="/login" element={user ? <Navigate to="/dashboard" /> : <Login />} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/clients" element={<PrivateRoute><Clients /></PrivateRoute>} />
          <Route path="/payments" element={<PrivateRoute><Payments /></PrivateRoute>} />
          <Route path="/classes" element={<PrivateRoute><Classes /></PrivateRoute>} />
          <Route path="/attendance" element={<PrivateRoute><Attendance /></PrivateRoute>} />
          <Route path="/modos" element={<PrivateRoute><Modos /></PrivateRoute>} />
          <Route path="/whatsapp" element={<PrivateRoute><WhatsAppConfig /></PrivateRoute>} />
          <Route path="/prices" element={<PrivateRoute><Prices /></PrivateRoute>} />
          <Route path="/" element={<Navigate to="/portal" replace />} />
        </Routes>
      </Content>
      <Footer style={{ textAlign: 'center', padding: '10px', background: '#111113', color: '#444', fontSize: 12 }}>
        FEMMBOX ©2026
      </Footer>
    </Layout>
  )
}

function App() {
  return (
    <ConfigProvider
      locale={esES}
      theme={{
        token: {
          colorPrimary: '#ff1493',
          colorBgBase: '#111113',
          colorTextBase: '#f0f0f0',
          colorBgContainer: '#1e1e22',
          colorBorder: '#2a2a2e',
          colorBgElevated: '#282830',
          borderRadius: 14,
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
        },
        components: {
          Card: {
            colorBgContainer: '#1e1e22',
            borderRadiusLG: 16,
            paddingLG: 20
          },
          Menu: {
            colorItemBgSelected: 'rgba(255,20,147,0.15)',
            colorItemTextSelected: '#ff1493',
            borderRadiusItem: 8
          }
        },
        algorithm: theme.darkAlgorithm
      }}
    >
      <AuthProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </AuthProvider>
    </ConfigProvider>
  )
}

export default App
